<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div epub:type="bodymatter">
<section epub:type="division">
<a id="pageviii"></a>
<div class="fullpage" id="img2"><a id="fm2"></a><img alt="" src="Images/viii.jpg"/>
<p class="caption">In a powerful evocation of Tesla’s formidable legacy, an electrical storm at the Kennedy Space Center in Cape Canaveral, Florida, creates an eerie tapestry of light in the hours preceding the launch of the space shuttle <em>Challenger</em> in 1983.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454931959_epub_fm2_r1.vue?69402a8b